// import Vue from 'vue'

export const USER_SIGNIN = 'USER_SIGNIN';  //登录成功
export const USER_SIGNOUT = 'USER_SIGNOUT';  //退出登录
export const POPUP_LOGIN = 'POPUP_LOGIN';  //登录弹窗
export const UPDATE_USER = 'UPDATE_USER';  //登录E弹窗

export default {
  state:{
    token:window.localStorage.getItem('token') || '',
    loginFlag:false,
    user:window.localStorage.getItem('user') || {}
  },
  mutations: {
    [USER_SIGNIN](state,user){
      window.localStorage.setItem('token',user.token);
      window.localStorage.setItem('user',user.user);
      state.token = user.token;
      state.user = user.user;
    },
    [USER_SIGNOUT](state){
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('user');
      state.token = '';
      state.user = {}
      // Object.keys(state).forEach(k => Vue.delete(state,k))
    },
    [POPUP_LOGIN](state,flag){
      state.loginFlag = flag
    },
    [UPDATE_USER](state,user){
      window.localStorage.setItem('user',user.user);
      state.user = user.user;
    }
  },
  actions:{
    [USER_SIGNIN]({commit},user){
      commit(USER_SIGNIN,user)
    },
    [USER_SIGNOUT]({commit}){
      commit(USER_SIGNOUT)
    },
    [POPUP_LOGIN]({commit},flag){
      commit(POPUP_LOGIN,flag)
    },
    [UPDATE_USER]({commit},user){
      commit(UPDATE_USER,user)
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/user.js